import type {
  IResponseApi,
  IResponseApiSearch
} from '@/modules/Core/interfaces/api/IApis'
import { BaseService } from '@/modules/Core/services/BaseService'
import type { IAuthItem } from '@/modules/Autenticacion/interfaces' // Asegúrate de tener la interfaz definida
import type { AxiosResponse } from 'axios'
export class PermisosService extends BaseService<IAuthItem> {
  constructor () {
    super({
      baseUrl: 'system/profiles/'
    })
  }
  async list (): Promise<AxiosResponse<IResponseApi<IAuthItem[]>>> {
    return this.http.get<IResponseApi<IAuthItem[]>>(`/list/2`)
  }

  // Buscar elementos con parámetros
  async search (
    params: Record<string, string | number>
  ): Promise<AxiosResponse<IResponseApiSearch<IAuthItem[]>>> {
    return this.http
      .get<IResponseApiSearch<IAuthItem[]>>(`/search/2`, { params })
      .catch(this.errorHandle)
  }
}
